import cn from "classnames";
import cloneDeep from "lodash/cloneDeep";
import { useMemo } from "react";
import HeaderVariant1 from "@/components/site-builder/BaseModule/HeaderVariant1";
import HorizontalHeader from "@/components/site-builder/BaseModule/HorizontalHeader";
import Wrapper from "@/components/site-builder/BaseModule/Wrapper";
import {
  SiteBuilderModuleHeaderAlignment,
  SiteBuilderModuleLayoutSize,
} from "@/constants/site-builder";
import useCreateRGBAColorFromColorVariant from "@/hooks/useCreateRGBAColorFromColorVariant";
import { getSizeByPredefinedSize } from "@/utils/style/getSizeByPredefinedSize";
import type { HeroModuleType } from "../types";
import s from "./HeroVariant2.module.scss";

export interface HeroVariant2Props {
  module: HeroModuleType;
}

export default function HeroVariant2(props: HeroVariant2Props) {
  const { module } = props;
  const {
    style: {
      display: { layoutSize, headerAlignment },
      background: {
        color: { colorVariant },
      },
    },
    settings: {
      container: { minHeight },
    },
    body: { image },
  } = module;

  // Update background settings with custom ones
  const moduleClone = useMemo(() => {
    const clone = cloneDeep(module);

    if (image.source) {
      clone.style.background.image.enabled = true;
      clone.style.background.image.image = image;
    }

    return clone;
  }, [image, module]);

  const tileColor = useCreateRGBAColorFromColorVariant(colorVariant, 0.9);
  const tileStyle = {
    minHeight: getSizeByPredefinedSize(minHeight),
    backgroundColor: tileColor || undefined,
  };
  const tileClassName = cn(s.tile, {
    "flex-center": headerAlignment === SiteBuilderModuleHeaderAlignment.Middle,
  });

  return (
    <Wrapper module={moduleClone} className={s.wrapper}>
      <HorizontalHeader
        module={module}
        headerContent={
          <div className={tileClassName} style={tileStyle}>
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
              <HeaderVariant1 module={module} />
            </div>
          </div>
        }
        fluid={layoutSize === SiteBuilderModuleLayoutSize.FullScreen}
      />
    </Wrapper>
  );
}
